import { Methods } from "@newview/infrastructure";
import {NewviewOaBaseApi} from "./NewviewOaBaseApi";


export class ExpressInfoApi extends NewviewOaBaseApi {

  public get ControllerName(): any {
    return 'expressInfo'
  }

}